import React from 'react';
import { Box, Paper, Typography, Divider, useTheme } from '@mui/material';
import { reviewThemeExtensions } from '../../theme/reviewTheme';

const SectionWrapper = ({ 
  title, 
  children, 
  ...props 
}) => {
  const theme = useTheme();
  const reviewStyles = reviewThemeExtensions.components.reviewSection(theme);
  
  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        ...reviewStyles,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...props.sx
      }}
      {...props}
    >
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Paper>
  );
};

export default SectionWrapper;